import axiosInstance from "../data/interface/axiosInstance";

export interface PaginationParams {
  page: number;
  pageSize: number;
  searchTerm?: string;
  startDate?: string;
  endDate?: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export const getAllSanitizedReports = async (params?: PaginationParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    queryParams.append('page', params.page.toString());
    queryParams.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) {
      queryParams.append('searchTerm', params.searchTerm);
    }
    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }
  }
  
  const res = await axiosInstance.get(`/SanitizedReports/GetAllSanitizedReports?${queryParams}`);
  return res.data.dataModel || { data: [], totalCount: 0, page: 1, pageSize: 10, totalPages: 0 };
};

export const addUpdateSanitizedReport = async (payload: any) => {
  return axiosInstance.post("/SanitizedReports/AddUpdateSanitizedReport", payload);
};

export const deleteSanitizedReportById = async (id: number) => {
  return axiosInstance.delete(`/SanitizedReports/DeleteSanitizedReportById?id=${id}`);
};

export const getAllSanitizedReportTypes = async () => {
  const res = await axiosInstance.get("/SanitizedReports/GetAllReports");
  return res.data.dataModel || [];
};

// Own-module (sanitizedreports.view) source for the submission picker. Replaces the cross-module
// AuditReportSubmissions/ReportSubmissions GETs. Returns the submissions for a single report.
export const getSubmissionsByReportType = async (
  reportId: number,
  reportName: string,
  reportType: string
) => {
  const params = new URLSearchParams();
  params.append("reportId", String(reportId));
  params.append("reportName", reportName || "");
  params.append("reportType", reportType || "");
  const res = await axiosInstance.get(
    `/SanitizedReports/GetSubmissionsByReportType?${params}`
  );
  return res.data.dataModel || [];
};

export const getAllReportsWithSubmissions = async (params?: PaginationParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    queryParams.append('page', params.page.toString());
    queryParams.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) {
      queryParams.append('searchTerm', params.searchTerm);
    }
    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }
  }
  
  const res = await axiosInstance.get(`/SanitizedReports/GetAllReportsWithSubmissions?${queryParams}`);
  return res.data.dataModel || { data: [], totalCount: 0, page: 1, pageSize: 10, totalPages: 0 };
};